
import { APIFeatures } from '../../../../../core/util/apifeatures';
import { BaseContext } from '../../../../../utils/basecontext';
import { OTPCheckDtoImpl } from '../../../../../core/dto/otp/otpcheck/otpcheckdto';
import { UIComponentHandler, UIComponentImpl, UIComponentState, UIDataModel } from '../../../../toolkit/uicomponent';
import { APIModel, APIModelHandler } from '../../../../toolkit/uicomponentapimodel';
import { UIComponentCSSStyle } from '../../../../toolkit/uicomponentcss';
import { UIComponentView } from '../../../../toolkit/uicomponentview';
import { ChildComponentProps } from '../../../mainwrappercomponent';
import { RoutingFeatures } from '../../../navigation/routingfeature';
import { CreateAccountOTPMessageAPIModel, CreateAccountOTPMessageAPIModelImpl } from './createaccountotpmessageapimodel';
import { CreateAccountOTPMessageCSSStyleImpl } from './createaccountotpmessagecss';
import { CreateAccountOTPMessageViewImpl } from './createaccountotpmessageview';
import { AlertType } from '../../../../toolkit/alert/alerttype';
import { SendOTPDto } from 'src/com/sixdee/crbtportal/core/dto/otp/sendotp/sendotpdto';

export interface CreateAccountOTPMessageComponentProps extends ChildComponentProps
{
    msisdn: string;
    sectoken: string;
}

export interface CreateAccountOTPMessageComponentState extends UIComponentState
{
    isOTPMessageShow: boolean;
    isCreateAccountSuccess: boolean;
    isResendButtonRestricted:boolean;
    sectoken: string;
  
}

export interface CreateAccountOTPMessageComponentHandler extends UIComponentHandler
{
    onCloseButtonClicked():void;
    onLogoClicked(): void;
    onResendOtpClick():void;
    onSubmitButtonClick():void;
    onLoginButtonClick():void;
}

export class CreateAccountOTPMessageComponent extends UIComponentImpl<CreateAccountOTPMessageComponentProps, CreateAccountOTPMessageComponentState, UIDataModel>
implements CreateAccountOTPMessageComponentHandler
{
    private timer:any;
    private countDownTimerInterval:any;
    private duration = Number(this.getContext().getProperty().getResendOtpTimeout());
    private countDownSeconds = this.duration/1000;

    constructor(props: CreateAccountOTPMessageComponentProps)
    {
        super(props);

        this.state = {isOTPMessageShow : true, sectoken: props.sectoken, isCreateAccountSuccess: false, isResendButtonRestricted:false};
    }
    startCountDown() 
    {
        
        let countDownTimer = document.getElementById("countdown");

        let formatTime = (time:any) =>
        `${String(Math.floor(time / 60)).padStart(2, "0")}:${String(
          time % 60
        ).padStart(2, "0")}`;
         
           this.countDownTimerInterval= setInterval(async() => {
             
        
             if (this.countDownSeconds < 0 ) {
               clearInterval(this.countDownTimerInterval);
               countDownTimer!==null && (countDownTimer.innerHTML = " ");
             }
             else{
              
             
            countDownTimer!==null && (countDownTimer.innerHTML = String(formatTime(this.countDownSeconds--)));
             }
            
           }, 900);
      }
    protected createComponentView(applicationContext: BaseContext, uiComponentHandler: UIComponentHandler): UIComponentView<UIDataModel>
    {
        return new CreateAccountOTPMessageViewImpl(applicationContext, uiComponentHandler);
    }

    protected createComponentCSS(applicationContext: BaseContext): UIComponentCSSStyle
    {
        return new CreateAccountOTPMessageCSSStyleImpl(applicationContext);
    }
    onLogoClicked(): void 
    {
        this.props.routeNextFeature(RoutingFeatures.HOME, false);
    }
    protected createAPIModel(applicationContext: BaseContext, apiModelHandler: APIModelHandler): APIModel
    {
         return new CreateAccountOTPMessageAPIModelImpl(applicationContext, apiModelHandler);
    }

    onCloseButtonClicked():void
    {   
        this.setState({isOTPMessageShow: !this.state.isOTPMessageShow});
    }

    onSubmitButtonClick():void
    {
        this.setState({isOTPMessageShow: false});
        if(this.getView().validate())
        {
            (this.getView() as CreateAccountOTPMessageViewImpl).showLoader();
            let otpDto = (this.getView().getData() as OTPCheckDtoImpl);
            otpDto.setMsisdn(this.props.msisdn);
            otpDto.setSecToc(this.state.sectoken);
            this.getAPIModel().otpCheck(otpDto);
        }
    }

    onSuccess(feature: APIFeatures, description: string, data: any): void 
    {

        (this.getView() as CreateAccountOTPMessageViewImpl).dismissLoader();
        if(feature === APIFeatures.OTP_CHECK)
        {
            this.setState({isCreateAccountSuccess: true});
        }
        else if(feature === APIFeatures.SEND_OTP)
        {
            this.setState({isOTPMessageShow: true, sectoken: (data as SendOTPDto).getSecToc()});
            this.setState({isResendButtonRestricted:true});
            this.countDownSeconds = this.duration/1000;
            this.startCountDown();
            this.timer = setTimeout(this.setState.bind(this, {isResendButtonRestricted:false}), Number(this.duration));
           
        }
    }
    onFailure(feature: APIFeatures, description: string, data: any): void 
    {
       
     (this.getView() as CreateAccountOTPMessageViewImpl).dismissLoader();
 
     (this.getView() as CreateAccountOTPMessageViewImpl).showPopup("",description,AlertType.ERROR);

    }

    onResendOtpClick(): void 
    {
        if(this.state.isResendButtonRestricted === true)
        {
           
        }
        else
        {
            
            (this.getView() as CreateAccountOTPMessageViewImpl).showLoader();
        this.setState({isOTPMessageShow: false});

        this.getAPIModel().resendOtp(this.props.msisdn);
        }
    }
    UNSAFE_componentWillMount()
    {
        super.UNSAFE_componentWillMount();
        console.log("timerstoped");
        clearTimeout(this.timer);


    }
    onLoginButtonClick(): void 
    {
        this.props.routeNextFeature(RoutingFeatures.LOGIN, false);
    }

    getAPIModel(): CreateAccountOTPMessageAPIModel {
        return super.getAPIModel() as CreateAccountOTPMessageAPIModel;
    }
}


// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/ui/components/login/createaccountotp/createaccountotpmessagecomponent/createaccountotpmessagecomponent.tsx